/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssetList } from '../models/AssetList';
import type { Attachment } from '../models/Attachment';
import type { BalanceRead } from '../models/BalanceRead';
import type { Body_chatbot_upload_asset } from '../models/Body_chatbot_upload_asset';
import type { ChatPlanRead } from '../models/ChatPlanRead';
import type { MessagePage } from '../models/MessagePage';
import type { MessageRead } from '../models/MessageRead';
import type { MessageUpdate } from '../models/MessageUpdate';
import type { PermissionAction } from '../models/PermissionAction';
import type { PermissionDecisionRequest } from '../models/PermissionDecisionRequest';
import type { PermissionList } from '../models/PermissionList';
import type { PlanDecisionRequest } from '../models/PlanDecisionRequest';
import type { PlanUpdate } from '../models/PlanUpdate';
import type { SavePexelsRequest } from '../models/SavePexelsRequest';
import type { SummarizeRequest } from '../models/SummarizeRequest';
import type { ThreadPage } from '../models/ThreadPage';
import type { ThreadRead } from '../models/ThreadRead';
import type { ThreadUpdate } from '../models/ThreadUpdate';
import type { TurnRequest } from '../models/TurnRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChatbotService {
    /**
     * Create Thread
     * Open an empty chat thread for the brand, owned by the signed-in account.
     * @param brandId
     * @param useBrandBook
     * @param useFiles
     * @returns ThreadRead Successful Response
     * @throws ApiError
     */
    public static createThread(
        brandId: number,
        useBrandBook: boolean = true,
        useFiles: boolean = true,
    ): CancelablePromise<ThreadRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chatbot/threads',
            query: {
                'brand_id': brandId,
                'use_brand_book': useBrandBook,
                'use_files': useFiles,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Threads
     * Threads newest-first. Pass the previous response's `next_cursor` to page on.
     * @param brandId
     * @param archived
     * @param limit
     * @param nextCursor
     * @returns ThreadPage Successful Response
     * @throws ApiError
     */
    public static listThreads(
        brandId: number,
        archived: boolean = false,
        limit: number = 20,
        nextCursor?: (string | null),
    ): CancelablePromise<ThreadPage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chatbot/threads',
            query: {
                'brand_id': brandId,
                'archived': archived,
                'limit': limit,
                'next_cursor': nextCursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Thread
     * Rename a thread, archive it, or restore it.
     * @param threadId
     * @param brandId
     * @param requestBody
     * @returns ThreadRead Successful Response
     * @throws ApiError
     */
    public static patchThread(
        threadId: string,
        brandId: number,
        requestBody: ThreadUpdate,
    ): CancelablePromise<ThreadRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/chatbot/threads/{thread_id}',
            path: {
                'thread_id': threadId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Thread Messages
     * The newest messages, oldest-first within the page; `next_cursor` walks backwards.
     * @param threadId
     * @param brandId
     * @param limit
     * @param nextCursor
     * @returns MessagePage Successful Response
     * @throws ApiError
     */
    public static getThreadMessages(
        threadId: string,
        brandId: number,
        limit: number = 50,
        nextCursor?: (string | null),
    ): CancelablePromise<MessagePage> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chatbot/threads/{thread_id}/messages',
            path: {
                'thread_id': threadId,
            },
            query: {
                'brand_id': brandId,
                'limit': limit,
                'next_cursor': nextCursor,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Message
     * Send a message and stream the assistant's reply as server-sent events.
     *
     * Events arrive in order: `turn_started`, then `text_delta` repeatedly with
     * `text_end` closing each block, `credit_balance`, and exactly one `complete`
     * or `error` to finish. Disconnecting does not cancel the turn.
     * @param threadId
     * @param brandId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postMessage(
        threadId: string,
        brandId: number,
        requestBody: TurnRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chatbot/threads/{thread_id}/messages',
            path: {
                'thread_id': threadId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Decision
     * Answer a `pending_permission` event and stream the rest of the turn.
     *
     * `once` runs the tool this time, `always` also stores the permission for the
     * brand, `deny` hands the model a refusal and lets it carry on.
     * @param threadId
     * @param brandId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postDecision(
        threadId: string,
        brandId: number,
        requestBody: PermissionDecisionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chatbot/threads/{thread_id}/messages/decision',
            path: {
                'thread_id': threadId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Plan
     * Replace a proposed plan's steps with the user's edit, before it is approved.
     * @param threadId
     * @param planId
     * @param brandId
     * @param requestBody
     * @returns ChatPlanRead Successful Response
     * @throws ApiError
     */
    public static patchPlan(
        threadId: string,
        planId: string,
        brandId: number,
        requestBody: PlanUpdate,
    ): CancelablePromise<ChatPlanRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/chatbot/threads/{thread_id}/plans/{plan_id}',
            path: {
                'thread_id': threadId,
                'plan_id': planId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Plan Decision
     * Answer a proposed or paused plan and stream the turn it starts.
     *
     * `approve` runs a proposal, `revise` sends it back with `feedback`, `retry` and
     * `skip` carry on from a failed step, and `cancel` drops the plan. Each change to
     * the plan arrives as a `plan_updated` event.
     * @param threadId
     * @param planId
     * @param brandId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postPlanDecision(
        threadId: string,
        planId: string,
        brandId: number,
        requestBody: PlanDecisionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chatbot/threads/{thread_id}/plans/{plan_id}/decision',
            path: {
                'thread_id': threadId,
                'plan_id': planId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Patch Message
     * Set or clear thumbs-up / thumbs-down feedback on a message.
     * @param messageId
     * @param brandId
     * @param requestBody
     * @returns MessageRead Successful Response
     * @throws ApiError
     */
    public static patchMessage(
        messageId: string,
        brandId: number,
        requestBody: MessageUpdate,
    ): CancelablePromise<MessageRead> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/chatbot/messages/{message_id}',
            path: {
                'message_id': messageId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Post Summarize
     * Compress the thread's older turns into a running summary.
     *
     * Answers the `needs_summarization` event. `scope` is how much of the
     * un-summarized conversation to fold in: "70" or "100" percent. Messages stay
     * readable; only what the model replays gets shorter.
     * @param threadId
     * @param brandId
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    public static postSummarize(
        threadId: string,
        brandId: number,
        requestBody: SummarizeRequest,
    ): CancelablePromise<Record<string, any>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chatbot/threads/{thread_id}/summarize',
            path: {
                'thread_id': threadId,
            },
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Upload Asset
     * Store a file the user attached, returning the attachment to send with a message.
     * @param brandId
     * @param formData
     * @returns Attachment Successful Response
     * @throws ApiError
     */
    public static uploadAsset(
        brandId: number,
        formData: Body_chatbot_upload_asset,
    ): CancelablePromise<Attachment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chatbot/assets/upload',
            query: {
                'brand_id': brandId,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Save Pexels
     * Copy a Pexels stock file into the brand's own assets.
     * @param brandId
     * @param requestBody
     * @returns Attachment Successful Response
     * @throws ApiError
     */
    public static savePexels(
        brandId: number,
        requestBody: SavePexelsRequest,
    ): CancelablePromise<Attachment> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chatbot/assets/save-pexels',
            query: {
                'brand_id': brandId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * List Assets
     * The brand's chat assets, newest first.
     * @param brandId
     * @param limit
     * @returns AssetList Successful Response
     * @throws ApiError
     */
    public static listAssets(
        brandId: number,
        limit: number = 100,
    ): CancelablePromise<AssetList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chatbot/assets',
            query: {
                'brand_id': brandId,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Permissions
     * List the brand's standing 'always allow' tool permissions.
     * @param brandId
     * @returns PermissionList Successful Response
     * @throws ApiError
     */
    public static getPermissions(
        brandId: number,
    ): CancelablePromise<PermissionList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chatbot/permissions',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete Permission
     * Revoke a standing permission for a (tool, action) pair.
     * @param brandId
     * @param toolName
     * @param action
     * @returns void
     * @throws ApiError
     */
    public static deletePermission(
        brandId: number,
        toolName: string,
        action: PermissionAction,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/chatbot/permissions',
            query: {
                'brand_id': brandId,
                'tool_name': toolName,
                'action': action,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Credit Balance
     * The brand's ad-credit allowance and how much of it is left.
     * @param brandId
     * @returns BalanceRead Successful Response
     * @throws ApiError
     */
    public static getCreditBalance(
        brandId: number,
    ): CancelablePromise<BalanceRead> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chatbot/balance',
            query: {
                'brand_id': brandId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
